<div class="row mt-md-2">
  <div class="col-md-6 col-sm-12">
    <cap-kopfdatenelement [histInfo]="entry.version?.histInfo" [value]="entry.version?.name" label="Name"></cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="entry.version?.histInfo" [value]="entry.version?.vorname" label="Vorname"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="entry.version?.histInfo"
      [metaData]="entry.version?.mWeitereVornamen"
      [value]="entry.version?.weitereVornamen"
      label="WeitereVornamen"></cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="entry.version?.histInfo" label="Geburtsdatum">
      @if (entry.version.mGeburtsdatum.access !== "NONE") {
        <span>{{ entry.version.geburtsdatum | dayMonthYearDate }}</span>
      } @else {
        <span>{{ "NotAvailable" | translate }}</span>
      }
    </cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="entry.version?.histInfo" [value]="entry.version?.ledigname" label="Ledigname"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="entry.version?.histInfo"
      [metaData]="entry.version?.mNameEltern"
      [value]="entry.version?.nameEltern"
      label="NameDerEltern"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="entry.version?.histInfo"
      [metaData]="entry.version?.mNameEhegatte"
      [value]="entry.version?.nameEhegatte"
      label="NameEhegatte"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="entry.version?.histInfo"
      [metaData]="entry.version?.mNameAlias"
      [value]="entry.version?.nameAlias"
      label="Alias"></cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="entry.version?.histInfo" label="AHVNummer">
      @if (entry.version.mAhvNummer.access !== "NONE") {
        <span>{{ entry.version?.ahvNummer?.ahv11?.ahvnummer | formatAhv }}</span>
      } @else {
        <span>{{ "NotAvailable" | translate }}</span>
      }
    </cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="entry.version?.histInfo" label="AHVVersichertennummer">
      @if (entry.version.mAhvNummer.access !== "NONE") {
        <span>{{ entry.version?.ahvNummer?.ahv13?.ahvnummer13 | formatAhv }}</span>
      } @else {
        <span>{{ "NotAvailable" | translate }}</span>
      }
    </cap-kopfdatenelement>
  </div>
  <div class="col-md-6 col-sm-12">
    <cap-kopfdatenelement [histInfo]="entry.version?.histInfo" [value]="entry.version?.art | translate" label="Art"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="entry.version?.histInfo"
      [metaData]="entry.version?.mHeimatort"
      [value]="entry.version?.heimatort"
      label="Heimatort"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="entry.version?.histInfo"
      [metaData]="entry.version?.mNationalitaet"
      [value]="entry.version?.land?.text | translateName"
      label="Nationalitaet"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="entry.version?.histInfo"
      [metaData]="entry.version?.mGeschlecht"
      [value]="entry.version?.geschlecht | translate"
      label="Geschlecht"></cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="entry.version?.histInfo" [value]="entry.version?.uid | formatUid" label="UID"></cap-kopfdatenelement>

    <cap-kopfdatenelement
      [histInfo]="entry.version?.histInfo"
      [metaData]="entry?.mEgbpid"
      [value]="entry.egbpid"
      label="EGBPID"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="entry.version?.histInfo"
      [metaData]="entry.version?.mNrIrole"
      [value]="entry.version?.nrIrole"
      label="NRIROLE"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="entry.version?.histInfo"
      [metaData]="entry?.mKantPersonId"
      [value]="entry.mKantPersonId?.access === 'ALLOWED' ? entry.kantPersonId?.value : ('NotAvailable' | translate)"
      label="KantonalePersonenID">
    </cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="entry.version?.histInfo"
      [value]="entry.version?.personenGruppe?.text | translateName"
      label="Personengruppe"></cap-kopfdatenelement>

    <cap-kopfdatenelement [value]="entry.datenquelle | translate" label="Datenquelle"></cap-kopfdatenelement>
  </div>
</div>
